import React, { useEffect, useRef } from "react";
import moment from "moment";

export default function MobileMonthNavigation({
  monthKeys = [],
  activeMonth,
  onSelectMonth,
}) {
  const railRef = useRef(null);

  useEffect(() => {
    const rail = railRef.current;
    const selected = rail?.querySelector('[aria-current="date"]');
    if (!rail || !selected || !rail.clientWidth) return;

    const railBox = rail.getBoundingClientRect();
    const selectedBox = selected.getBoundingClientRect();
    rail.scrollTo({
      left: rail.scrollLeft + selectedBox.left - railBox.left
        - (rail.clientWidth - selectedBox.width) / 2,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto" : "smooth",
    });
  }, [activeMonth, monthKeys]);

  return (
    <nav className="aeonas-mobile-month-nav" aria-label="Kalendermonate">
      <div className="aeonas-mobile-month-rail" ref={railRef}>
        {monthKeys.map((key) => {
          const selected = key === activeMonth;
          const month = moment(key, "YYYY-MM").locale("de");
          return (
            <button
              key={key}
              type="button"
              className={selected ? "aeonas-month active" : "aeonas-month"}
              aria-current={selected ? "date" : undefined}
              aria-label={month.format("MMMM YYYY")}
              onClick={() => onSelectMonth(key)}
            >
              <span>{month.format("MMM").replace(".", "")}</span>
              <small>{month.format("YYYY")}</small>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
